export default function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md border-b-2 border-gray-900">
      <div className="max-w-7xl mx-auto px-8 py-5">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/28aea38028462401e679c040d07ad215.png" 
                alt="PCS Premier Contracting Services"
                className="h-12 w-auto"
              />
            </a>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a 
              href="#about" 
              className="whitespace-nowrap cursor-pointer text-gray-700 hover:text-blue-600 font-semibold transition-colors"
            >
              About Us
            </a>
            <a 
              href="#services" 
              className="whitespace-nowrap cursor-pointer text-gray-700 hover:text-blue-600 font-semibold transition-colors"
            >
              Services
            </a>
            <a 
              href="#contact" 
              className="whitespace-nowrap cursor-pointer text-gray-700 hover:text-blue-600 font-semibold transition-colors"
            >
              Contact
            </a>
            <a 
              href="#contact" 
              className="whitespace-nowrap cursor-pointer bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-bold px-6 py-2 rounded-lg transition-all duration-300"
            >
              Get a Quote
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden cursor-pointer text-gray-700 hover:text-blue-600"
            onClick={() => {
              const menu = document.getElementById('mobile-menu');
              if (menu) {
                menu.classList.toggle('hidden');
              }
            }}
          >
            <i className="ri-menu-line text-2xl w-6 h-6 flex items-center justify-center"></i>
          </button>
        </div>

        {/* Mobile Menu */}
        <div id="mobile-menu" className="hidden md:hidden mt-4 pb-4">
          <nav className="flex flex-col gap-4">
            <a 
              href="#about" 
              className="whitespace-nowrap cursor-pointer text-gray-700 hover:text-blue-600 font-semibold transition-colors"
            >
              About Us
            </a>
            <a 
              href="#services" 
              className="whitespace-nowrap cursor-pointer text-gray-700 hover:text-blue-600 font-semibold transition-colors"
            >
              Services
            </a>
            <a 
              href="#contact" 
              className="whitespace-nowrap cursor-pointer text-gray-700 hover:text-blue-600 font-semibold transition-colors"
            >
              Contact
            </a>
            <a 
              href="#contact" 
              className="whitespace-nowrap cursor-pointer bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-bold px-6 py-2 rounded-lg transition-all duration-300 text-center"
            >
              Get a Quote
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}
